"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var bind_1 = require("../bind");
var I18n = require("i18n-js");
var controlled_checkbox_1 = require("@reverbdotcom/commons/dist/components/controlled_checkbox");
var with_countries_apollo_1 = require("../components/addresses/with_countries_apollo");
var address_fields_1 = require("../components/shared/addresses/address_fields");
var address_summary_1 = require("../components/addresses/address_summary");
var checkout_billing_address_placeholder_1 = require("./checkout_billing_address_placeholder");
var selectable_credit_card_list_error_1 = require("./selectable_credit_card_list_error");
var CheckoutBillingAddressFormWithoutApolloCountries = /** @class */ (function (_super) {
    tslib_1.__extends(CheckoutBillingAddressFormWithoutApolloCountries, _super);
    function CheckoutBillingAddressFormWithoutApolloCountries(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            billingSameAsShippingSelected: true,
            address: props.billingAddress,
        };
        return _this;
    }
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.updateBillingSameAsShippingSelected = function (billingSameAsShippingSelected) {
        this.setState(billingSameAsShippingSelected);
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.countries = function () {
        return this.props.data.countries.countries;
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.billingSameAsShippingCheckbox = function () {
        if (!this.props.showBillingSameAsShippingOption) {
            return (React.createElement("input", { name: "payment[billing_address_same_as_shipping]", type: "hidden", value: "false" }));
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "label-with-checkbox mb-half" },
                React.createElement("input", { name: "payment[billing_address_same_as_shipping]", type: "hidden", value: "" + this.state.billingSameAsShippingSelected }),
                React.createElement(controlled_checkbox_1.default, { id: "payment_billing_address_same_as_shipping", fieldName: "billingSameAsShippingSelected", inputName: "billingSameAsShippingSelected", updateField: this.updateBillingSameAsShippingSelected, checked: this.state.billingSameAsShippingSelected }),
                React.createElement("label", { htmlFor: "payment_billing_address_same_as_shipping" }, I18n.t('discovery.checkoutBillingAddressForm.sameAsShippingAddress'))),
            this.displayDefaultAddress()));
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.displayDefaultAddress = function () {
        if (!this.state.billingSameAsShippingSelected) {
            return null;
        }
        return (React.createElement(address_summary_1.AddressSummary, { address: this.props.billingAddress, data: this.props.data }));
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.updateAddress = function (data) {
        this.setState({ address: data });
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.showBillingAddressForm = function () {
        if (!this.props.showBillingSameAsShippingOption) {
            return true;
        }
        return !this.state.billingSameAsShippingSelected;
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.buildInputName = function (inputName) {
        return "payment[billing_address][" + inputName + "]";
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.renderBillingAddressForm = function () {
        if (!this.showBillingAddressForm()) {
            return null;
        }
        return (React.createElement(address_fields_1.default, { name: this.state.address.name, address: this.state.address, addressTitle: I18n.t('discovery.checkoutBillingAddressForm.streetAddress'), onUpdate: this.updateAddress, showPhone: this.props.showPhoneField, countriesForSelect: this.countries(), buildInputName: this.buildInputName, phoneInputRequired: true }));
    };
    CheckoutBillingAddressFormWithoutApolloCountries.prototype.render = function () {
        if (this.props.data.loading) {
            return React.createElement(checkout_billing_address_placeholder_1.default, null);
        }
        if (this.props.data.error) {
            return React.createElement(selectable_credit_card_list_error_1.default, null);
        }
        return (React.createElement("div", { className: "module" },
            React.createElement("h3", { className: "heading-3 mb-1" }, I18n.t('discovery.checkoutBillingAddressForm.billingAddress')),
            this.billingSameAsShippingCheckbox(),
            this.renderBillingAddressForm()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CheckoutBillingAddressFormWithoutApolloCountries.prototype, "updateBillingSameAsShippingSelected", null);
    tslib_1.__decorate([
        bind_1.default
    ], CheckoutBillingAddressFormWithoutApolloCountries.prototype, "updateAddress", null);
    tslib_1.__decorate([
        bind_1.default
    ], CheckoutBillingAddressFormWithoutApolloCountries.prototype, "buildInputName", null);
    return CheckoutBillingAddressFormWithoutApolloCountries;
}(React.Component));
exports.CheckoutBillingAddressFormWithoutApolloCountries = CheckoutBillingAddressFormWithoutApolloCountries;
var CheckoutBillingAddressForm = with_countries_apollo_1.default(CheckoutBillingAddressFormWithoutApolloCountries);
exports.default = CheckoutBillingAddressForm;
//# sourceMappingURL=checkout_billing_address_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/checkout_billing_address_form.js
// module id = 3L61
// module chunks = 20 21 22